import React from 'react';
import { Typography } from 'antd';
import classNames from 'classnames';

const { Title, Paragraph } = Typography;

const WizardTitle = ({
  title,
  subtitle,
  size = 'default',
  centered = false,
  className,
  children,
}) => {
  // Size variants
  const sizeConfig = {
    large: { level: 3, className: 'wizard-title--large' },
    medium: { level: 4, className: 'wizard-title--medium' },
    default: { level: 5, className: 'wizard-title--default' },
  };

  const config = sizeConfig[size] || sizeConfig.default;

  const wrapperClass = classNames(
    'wizard-title',
    config.className,
    {
      'wizard-title--centered': centered,
    },
    className
  );

  return (
    <div className={wrapperClass}>
      {title && (
        <Title level={config.level} className='wizard-title__text'>
          {title}
        </Title>
      )}
      {subtitle && (
        <Paragraph className='wizard-title__subtitle'>{subtitle}</Paragraph>
      )}
      {children}
    </div>
  );
};

export default WizardTitle;
